import { type InferOutput, minLength, object, pipe, string } from 'valibot'

export const shipmentOrderImportFormValueSchema = object({
  fileKey: pipe(string(), minLength(1)),
  fileName: pipe(string(), minLength(1))
})

/**
 * 配送依頼インポートのフォーム値
 */
export type ShipmentOrderImportFormValue = InferOutput<
  typeof shipmentOrderImportFormValueSchema
>
